var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user_info_form user_info_form_contact"},[_c('h4',[_vm._v("연락처")]),_c('p',{staticClass:"description"},[_vm._v(" 정확한 연락처를 입력해주세요. 정확하지 않을 경우 소득신고가 불가능하여 입금이 불가능할 수 있습니다. ")]),_c('tel-no-form',{on:{"update":_vm.updateTelNo}}),_c('address-form',{on:{"update":_vm.updateAddress}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }